import React from 'react'
import logo from '../../src/assets/Img/logo-wide.png'
const Nav = () => {
  return (
    

<nav className="static bg-white border-gray-200 flex items-center justify-center border-b border-gray-200">
  <div className=" max-w-screen-xl flex flex-wrap items-center  justify-center px-4">
    <a className="flex justify-center items-center space-x-3 rtl:space-x-reverse">
        <img src={logo} className="h-20" alt="Suntrust Logo" />
        {/* <span className="self-center text-2xl font-semibold whitespace-nowrap dark:text-white">Suntrust</span> */}
    </a>
    {/* <button data-collapse-toggle="navbar-default" type="button" className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600" aria-controls="navbar-default" aria-expanded="false">
        <span className="sr-only">Open main menu</span>
        <svg className="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 14">
            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M1 1h15M1 7h15M1 13h15"/>
        </svg>
    </button> */}
   
  </div>
</nav>

  )
}

export default Nav
